import React from "react";
// import sections
import Hero from "../components/sections/Hero";
import FeaturesTiles from "../components/sections/FeaturesTiles";
import FeaturesSplit from "../components/sections/FeaturesSplit";
import Testimonial from "../components/sections/Testimonial";
import Cta from "../components/sections/Cta";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

const Home = ({ isAuth, setIsAuth }) => {
  return (
    <>
      <Header />
      <Hero
        className="illustration-section-01"
        isAuth={isAuth}
        setIsAuth={setIsAuth}
      />
      <FeaturesTiles />
      <FeaturesSplit
        invertMobile
        topDivider
        imageFill
        className="illustration-section-02"
      />
      <Testimonial topDivider />
      <Cta split />
      <Footer />
    </>
  );
};

export default Home;
